import { Lock } from "lucide-react";
import React from "react";

export default function ViewOnlyAccessCard() {
  return (
    <div className="w-full bg-brand-lightOrange shadow-sm p-4 flex gap-3 items-start font-openSans">
      <div className="w-12 h-12 flex items-center justify-center rounded-xl border border-brand-orange text-xl">
        <Lock className="w-6 h-6 text-brand-orange" />
      </div>
      <div className="flex-1">
        <h3 className="text-base font-semibold text-brand-orange">
          View only access
        </h3>
        <p className="text-sm text-brand-textBlack">
          You have view-only access to this auction. The auction may not have
          started yet, or you are not logged in with the primary bidding
          account. Please log in with the primary account to get full access to
          the portal.
        </p>
      </div>
    </div>
  );
}
